import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import DroneAreasReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/drone-areas.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(DroneAreasReducer, defaultState, asyncActions);
};

type IDroneAreasContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const DroneAreasContext = createContext<Partial<IDroneAreasContext>>({
  state: defaultState,
}) as React.Context<IDroneAreasContext>;

const DroneAreasProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <DroneAreasContext.Provider value={{ ...reducer }}>
      {children}
    </DroneAreasContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useDroneAreasContext = () => useContext(DroneAreasContext);

export type IUseFireAgencyContext = ReturnType<typeof useDroneAreasContext>;

export { DroneAreasContext, DroneAreasProvider };
